import { useEffect, useState } from "react";
import { useApi } from "utils";

// Type dari API
import { PayloadChart, ChartDataItem } from "../types";

type ParamsType = {
    date: string;
    location_id: string;
};

// Daftar endpoint yang akan di-fetch
const endpoints = [
    {
        key: "totalPurchaseAmount",
        url: "/dashboard_purchase/get_total_purchase_amount",
        label: "Total Purchase Amount by Location",
    },
    {
        key: "averagePurchaseAmount",
        url: "/dashboard_purchase/get_average_purchase_amount",
        label: "Average Purchase Amount by Location",
    },
    {
        key: "totalSalesOrders",
        url: "/dashboard_purchase/get_total_sales_order",
        label: "Total Order by Location",
    },
    {
        key: "averageOrderPerTransaction",
        url: "/dashboard_purchase/get_average_sales_order",
        label: "Average Order per Transaction by Location",
    },
    {
        key: "averageLeadTime",
        url: "/dashboard_purchase/get_average_lead_time",
        label: "Average Lead Time by Location (Days)",
    },
    // Tambahkan endpoint baru di sini
] as const;

export function useChartList({ date, location_id }: ParamsType) {
    const api = useApi();
    const [dataChart, setDataChart] = useState<ChartDataItem[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    const params: Record<string, string | number> = { year_month: date };
    if (location_id) params.location_id = location_id;

    const fetchData = async () => {
        setLoading(true);
        try {
            const responses = await Promise.all(
                endpoints.map(async ({ key, url, label }) => {
                    try {
                        const res = await api.get(url, { params });
                        const data = res.data.payload;
                        return {
                            key,
                            label,
                            payload: Array.isArray(data) 
                                ? data as PayloadChart[] 
                                : data 
                                    ? [data as PayloadChart] 
                                    : [],
                        };
                    } catch {
                        return { key, label, payload: [] };
                    }
                })
            );
            setDataChart(responses);
        } catch (error) {
            setDataChart([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
        return () => setDataChart([]);
        // eslint-disable-next-line
    }, [date, location_id]);

    return { fetchData, dataChart, loading };
}
